import React, { useState } from "react";
import { StyleSheet, View } from "react-native";
import {
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { Text } from "@ui-kitten/components";
import "./index.css";
import Button from "components/Button";
import AgreementText from "components/AgreementText";
import {
  StripeTokenError,
  type StripePaymentFormProps,
  StripeTokenResponse,
} from "./StripePaymentForm";

const Form: React.FC<StripePaymentFormProps> = (props) => {
  const {
    btnText = "Confirm Purchase",
    onTokenReceived,
    disabled,
    loading,
    showAgreementText = true,
  } = props;
  const stripe = useStripe();
  const elements = useElements();

  const [fetchingToken, setFetchingToken] = useState(false);
  const [nameOnCard, setNameOnCard] = useState("");
  const [postalCode, setPostalCode] = useState("");

  const requestStripeToken = async () => {
    setFetchingToken(true);
    const response = (await stripe!.createToken(
      elements!.getElement("cardNumber")!
    )) as any;

    setFetchingToken(false);
    if (response.error) {
      onTokenReceived(response as StripeTokenError);
    } else {
      onTokenReceived(undefined, {
        ...response,
        nameOnCard,
        postalCode,
      } as StripeTokenResponse);
    }
  };

  return (
    <View>
      <div className="stripe-elements">
        <View style={styles.field}>
          <Text style={styles.label}>Name on card</Text>
          <div className="StripeElement custom-input ">
            <input
              type="text"
              value={nameOnCard}
              onChange={(e) => setNameOnCard(e.target.value)}
              data-testid="name-on-card"
            ></input>
          </div>
        </View>

        <View style={styles.field}>
          <Text style={styles.label}>Card Number</Text>
          <CardNumberElement options={{ placeholder: "" }} />
        </View>

        <View className="grid grid-cols-1 md:grid-cols-2 md:gap-4">
          <View style={styles.field}>
            <Text style={styles.label}>Expiration Date</Text>
            <CardExpiryElement options={{ placeholder: "" }} />
          </View>

          <View style={styles.field}>
            <Text style={styles.label}>CVC</Text>
            <CardCvcElement options={{ placeholder: "" }} />
          </View>
        </View>

        <View style={styles.field}>
          <Text style={styles.label}>Postal Code</Text>
          <div className="StripeElement custom-input ">
            <input
              type="text"
              value={postalCode}
              onChange={(e) => setPostalCode(e.target.value)}
              data-testid="postal-code"
            ></input>
          </div>
        </View>
      </div>

      {showAgreementText && (
        <AgreementText btnText={btnText} style={{ marginVertical: 30 }} />
      )}
      <Button
        testID="confirm-purchase-button"
        disabled={
          disabled ||
          loading ||
          fetchingToken ||
          nameOnCard === "" ||
          postalCode === ""
        }
        onPress={requestStripeToken}
        loading={fetchingToken || loading}
        style={{ marginTop: 10, marginBottom: 20 }}
      >
        {btnText}
      </Button>
    </View>
  );
};
const styles = StyleSheet.create({
  field: {
    marginBottom: 15,
  },
  label: {
    fontSize: 12,
    fontWeight: "500",
    marginBottom: 4,
    color: "black",
  },
});
export default Form;
